import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';
import posthog from 'posthog-js';
//import * as Sentry from '@sentry/angular';
//import { Integrations } from '@sentry/tracing';

// Sentry.init({
//   dsn: "https://aec8b5e3cc094fd7907fc8f1ec4a1b1c@o525949.ingest.sentry.io/5640799",
//   //environment : environment.production ? "production" : "local",
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ["localhost","https://api4.test.k8s.bigcct.be", "https://api.cullen-international.com"],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,

// });

// Initialize PostHog
posthog.init(
  environment.POSTHOG_KEY,
  {
    api_host: environment.POSTHOG_HOST,
    capture_pageview: true,
    autocapture: false, // Disable automatic event capturing
    person_profiles: 'identified_only', // Only create profiles for identified users
    loaded: function(posthog) {
      // Load feature flags when PostHog is ready
      posthog.reloadFeatureFlags();
      
      // Add a periodic reload of feature flags every 5 minutes
      setInterval(() => {
        posthog.reloadFeatureFlags();
      }, 5 * 60 * 1000);
      
      console.log('PostHog initialized with feature flags support');
    }
  }
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
